import React from "react";
import Overview from "../../Pages/Overview/Overview.jsx";
import NetworkAnalytics from "../../Pages/NetworkAnalytics/NetworkAnalytics.jsx";
import WifiAnalytics from "../../Pages/WifiAnalytics/WifiAnalytics";
import EndUserAnalytics from "../../Pages/EndUserAnalytics/EndUserAnalytics";
import ClientIntegrations from "../../Pages/ClientIntegrations/ClientIntegrations";
import OptionList from "./OptionList";
import Settings from "../SetttingsComponents/Settings";
import Account from "../AccountComponents/Account";
import GridView from "../GridViewComponents/GridView";
import Members from "../MembersComponents/Members.jsx";
import HelpIcon from "@material-ui/icons/Help";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import ReactImageFallback from "react-image-fallback";
import Popup from "reactjs-popup";
import CookieConsent from "react-cookie-consent";

// Observable Services
import { CompanyService } from "../../Classes/index";

import {
  IconButton,
  Tooltip,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
} from "@material-ui/core";
import {
  Brightness3,
  WbSunny,
  AccountCircle,
  AccountCircleOutlined,
} from "@material-ui/icons";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import io from "socket.io-client";
import KeycloakService from "../../Keycloak/KeycloakService";

import "./Main.css";
import UseObservable from "../../Helpers/UseObservable.js";
import initialStates from "../../Classes/InitialStates/account.initialStates.js";
import Helpers from "../../Helpers/Helpers.js";

const axios = require("axios");
const socket = io("wss://backend.ambeent.ai/", {
  transports: ["websocket"],
});

const Main = (props) => {
  const { t, i18n } = props;

  const [option, setoption] = React.useState(window.location.pathname);
  const [mode, setMode] = React.useState(0);
  const [anchor, setAnchor] = React.useState(null);
  const [lng, setLng] = React.useState(localStorage.getItem("i18nextLng"));
  const currentTheme = localStorage.getItem("theme")
    ? localStorage.getItem("theme")
    : "0";
  let history = useHistory();

  //Observables
  const { data: company } = UseObservable({
    observable: CompanyService.getInstance().get,
    initialState: initialStates.company,
  });

  // console.log(company);

  if (localStorage.getItem("companyId") === "googleLogin") {
    let path = `/GoogleSignUp`;
    history.push(path);
  }

  const handleoption = (opt) => {
    setoption(opt);
  };

  // Open drawer
  const onAccountClick = (e) => setAnchor(e.currentTarget);

  // Close drawer
  const onAccountMenuClose = () => setAnchor(null);

  //set dark mode
  function setdarkmode() {
    setMode(mode + 1);
    document.documentElement.setAttribute("data-theme", "dark");
    localStorage.setItem("theme", "dark");
  }

  //set light mode
  function setlightmode() {
    setMode(mode - 1);
    document.documentElement.setAttribute("data-theme", "light");
    localStorage.setItem("theme", "light");
  }
  // function getMonday(d) {
  //   d = new Date(d);
  //   var day = d.getDay(),
  //     diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
  //   return new Date(d.setDate(diff));
  // }

  function goToSettings() {
    window.history.pushState(null, null, "Settings");
    setoption("/Settings");
  }

  //option called account activate
  function activatedAccount() {
    window.history.pushState(null, null, "Account");
    setoption("/Account");
  }

  // Logout function
  function activatedLogout() {
    //set path to default when logout
    window.history.replaceState(null, null, "/");
    // Logouts from keycloak
    KeycloakService.doLogout();

    if (localStorage.getItem("ticketID") !== null) {
      socket.emit("leave", { ticket: localStorage.getItem("ticketID") });
    }
    // Clears localStorage values
    localStorage.clear();
    // Add login to disable first time open properties
    localStorage.setItem("login", "true");
  }

  //THEMA ICON BUTTON
  function Theme(props) {
    if (currentTheme) {
      document.documentElement.setAttribute("data-theme", currentTheme);
    }
    if (
      localStorage.getItem("theme") === "light" ||
      localStorage.getItem("theme") === null
    ) {
      return (
        <Tooltip
          title={
            <span className="tooltip-container">{t("chnageThemeTooltip")}</span>
          }
        >
          <IconButton
            style={{ color: "white", minWidth: "unset" }}
            onClick={() => setdarkmode()}
          >
            <WbSunny />
          </IconButton>
        </Tooltip>
      );
    }
    return (
      <Tooltip
        title={
          <span className="tooltip-container">{t("chnageThemeTooltip")}</span>
        }
      >
        <IconButton
          style={{ color: "white", minWidth: "unset" }}
          onClick={() => setlightmode()}
        >
          <Brightness3 />
        </IconButton>
      </Tooltip>
    );
  }

  //CALL ENDPOINTS -START useEffect METHOD
  React.useEffect(() => {
    if (lng === "en") {
      i18n.changeLanguage("en");
    } else {
      i18n.changeLanguage("tr");
    }

    // fetchs data from company info endpoints
    CompanyService.getInstance().fetchData();

    // eslint-disable-next-line
  }, [
    // eslint-disable-next-line
    localStorage.getItem("defaultCompanyId"), // eslint-disable-next-line
    localStorage.getItem("companyId"),
  ]);

  function changeLng(event) {
    setLng(event.target.value);
    i18n.changeLanguage(event.target.value);
    axios
      .post(
        "https://backend.ambeent.ai/ambeentcore/api/v1/User/UpdateLanguage",
        {
          companyId: localStorage.getItem("companyId"),
          email: localStorage.getItem("email"),
          language: event.target.value,
        }
      )
      .then((response) => {})
      .catch(function (error) {
        console.log(error);
      });
  }
  //CALL ENDPOINTS -FINISH useEffect METHOD

  //Change companyid to selected sites cmpany id
  const handleSites = (event) => {
    localStorage.setItem("companyId", event.target.value);
    localStorage.setItem("sitesChange", "true");
    if (event.target.value === localStorage.getItem("defaultCompanyId")) {
      localStorage.removeItem("siteName");
    }
    window.location.reload();
  };

  const sitesList = company?.sites?.map((item, index) => {
    if (localStorage.getItem("companyId") === item.companyId) {
      localStorage.setItem("siteName", item.name);
      return (
        <option selected className="sitesOption" value={item.companyId}>
          {item.name}
        </option>
      );
    } else {
      return (
        <option className="sitesOption" value={item.companyId}>
          {item.name}
        </option>
      );
    }
  });

  return (
    <div
      className="container-fluid"
      style={{ backgroundColor: "rgba(0, 10, 50, 1)" }}
    >
      <div className="row flex-xl-nowrap">
        {/* COMPANY NAME AND COMPANY PHOTO */}
        <div
          id="nav"
          className="col-12 col-md-3 col-xl-2 bd-sidebar menuscroll"
          style={{ height: "100%" }}
        >
          <div className="row">
            <div className="col-md-12 col-8">
              <div id="logoArea" className="col text-md-left logo">
                {company && (
                  <ReactImageFallback
                    src={company?.image}
                    fallbackImage="https://speedtest-cdn.ambeent.ai/logo/477dc836-4a63-41de-b4de-1a0c3921e7f7"
                    alt=""
                    id={localStorage.getItem("companyId") === "e4cd672b-8b91-4c9e-9044-326efe32e2b6" || localStorage.getItem("companyId") === "c7be73e5-921d-4512-bd8f-434b430818e9" ? "imgLogo2" : "imgLogo"}
                    onClick={() => {
                      // redirects to home page according to companytype
                      setoption(
                        Helpers.isCompanyISP() === true
                          ? "/Overview"
                          : "/EndUserAnalytics"
                      );
                      window.history.pushState(
                        null,
                        null,
                        Helpers.isCompanyISP() === true
                          ? "Overview"
                          : "EndUserAnalytics"
                      );
                    }}
                  />
                )}
                <b
                  id="companyName"
                  className="col-12 col-md-9 col-xl-10 bd-content"
                >
                  {localStorage.getItem("companyType") === "Partner" ? (
                    <select
                      id="sitesSelectOption"
                      style={{ background: "none" }}
                      onChange={handleSites}
                    >
                      <option
                        selected
                        className="sitesOption"
                        value={localStorage.getItem("defaultCompanyId")}
                      >
                        {company?.companyName}
                      </option>

                      {sitesList}
                    </select>
                  ) : (
                    company?.companyName
                  )}
                </b>
              </div>
            </div>
            <div className="col-md-12 col-4 text-right">
              <button
                id="menuButton"
                className="btn btn-link bd-search-docs-toggle d-md-none p-0 ml-3 collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#bd-docs-nav"
                aria-controls="bd-docs-nav"
                aria-expanded="false"
                aria-label="Toggle docs navigation"
              >
                <svg
                  src="data:image/png;base64,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"
                  viewBox="0 0 30 30"
                  width="30"
                  height="30"
                  focusable="false"
                >
                  <title>Menu</title>
                  <path
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    d="M4 7h22M4 15h22M4 23h22"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
          <nav
            className="collapse bd-links"
            id="bd-docs-nav"
            style={{ marginTop: "-25px", height: "100%" }}
          >
            <OptionList onSelectOption={handleoption} />
          </nav>
        </div>

        <div id="content-body" className="col-12 col-md-9 col-xl-10 bd-content">
          {/* TOP RIGHT MENU */}
          <div id="topMenu" className="row">
            <div className="col">
              {lng === "en" ? (
                <div id="whatsnews">
                  {" "}
                  What is New? Now, you can set your time zone from{" "}
                  <b id="goToSettings" onClick={goToSettings}>
                    Settings.
                  </b>{" "}
                </div>
              ) : (
                <div id="whatsnews">
                  {" "}
                  Yenilikler neler? Artık saat diliminizi{" "}
                  <b id="goToSettings" onClick={goToSettings}>
                    ayarlardan
                  </b>{" "}
                  düzenleyebilirsiniz.{" "}
                </div>
              )}
              <div id="rightMenu">
                <Popup
                  contentStyle={{
                    display: "flex",
                    backgroundColor: "transparent",
                    border: "none",
                  }}
                  trigger={
                    <IconButton id="helpButton" className="ml-1" edge="end">
                      <HelpIcon style={{ color: "white" }} />
                    </IconButton>
                  }
                  modal
                >
                  <iframe
                    title="videoFrame"
                    frameBorder="0"
                    width="970"
                    height="350"
                    src="https://www.youtube.com/embed/QTkQMRVWsvE"
                  ></iframe>
                </Popup>
                <Theme mode={mode} />
                <select
                  id="lngSelect"
                  className="MuiButtonBase-root"
                  onChange={changeLng}
                  defaultValue={lng === "en" ? "en" : "tr"}
                >
                  <option className="lng" value="en">
                    EN
                  </option>
                  <option className="lng" value="tr">
                    TR
                  </option>
                </select>
                <IconButton
                  className="ml-1"
                  edge="end"
                  onClick={onAccountClick}
                >
                  <AccountCircle style={{ color: "white" }} />
                </IconButton>
                <Popover
                  anchorEl={anchor}
                  open={!!anchor}
                  onClose={onAccountMenuClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  <ListItem onClick={() => activatedAccount()} button>
                    <ListItemIcon className="navbar-popover-list-item-icon">
                      <AccountCircleOutlined />
                    </ListItemIcon>
                    <ListItemText primary={localStorage.getItem("email")} />
                  </ListItem>
                  <ListItem onClick={() => activatedLogout()} button>
                    <ListItemIcon className="navbar-popover-list-item-icon">
                      <ExitToAppIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Logout")} />
                  </ListItem>
                </Popover>
              </div>
            </div>
          </div>

          {/* OPTIONS MENU */}

          {option === "/Overview" ? (
            <div>
              <Overview />
            </div>
          ) : option === "/Settings" ? (
            <div>
              <Settings />
            </div>
          ) : option === "/Account" ? (
            <div>
              <Account />
            </div>
          ) : option === "/GridView" ? (
            <div>
              <GridView />
            </div>
          ) : option === "/Members" ? (
            <div>
              <Members />
            </div>
          ) : option === "/NetworkAnalytics" ? (
            <div>
              <NetworkAnalytics />
            </div>
          ) : option === "/WifiAnalytics" ? (
            <div>
              <WifiAnalytics />
            </div>
          ) : option === "/EndUserAnalytics" ? (
            <div>
              <EndUserAnalytics />
            </div>
          ) : option === "/ClientIntegration" ? (
            <div>
              <ClientIntegrations />
            </div>
          ) : (
            <div>
              <Overview />
            </div>
          )}

          {/* COOKIE MENU */}

          <CookieConsent
            location="bottom"
            buttonText="Accept"
            style={{ background: "#2B373B" }}
            buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          >
            This website uses cookies to enhance the user experience.{" "}
          </CookieConsent>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(Main);
